// Module-level helper functions for academic
import { TCourse } from "../../../apis/academic/academic.interfaces";

/**
 * Checks if courses prerequisite is met for class creation
 * @param courses - Array of courses or undefined
 * @returns true if at least one course exists, false otherwise
 */
export const hasCoursePrerequisite = (
  courses: TCourse[] | undefined,
): boolean => {
  return !!courses && courses.length > 0;
};
